module.exports = __webpack_public_path__ + "a8aff3a66b9b688668340d04fff6f752.svg";